
/**
 * 뉴스 기본 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroBasicInfoAllOfTwo = {
  publishedAt: string;
  title: string;
};
